import PropTypes from "prop-types";

import { BETSHOP_BONUS_CONFIG_TYPE } from "constants/betshop.constants";

export default PropTypes.shape({
	enabled: PropTypes.bool,
	type: PropTypes.oneOf(Object.values(BETSHOP_BONUS_CONFIG_TYPE)),
	amount: PropTypes.number
});
